import { DocumentTypes } from 'src/types/common';
import * as Yup from 'yup';

export const DocumentTypeValidation = Yup.string()
  .oneOf(Object.values(DocumentTypes))
  .required('Selecciona el tipo de documento');

export const DocumentNumberValidation = Yup.string().when(
  ['documentType', 'document_type'],
  (_, schema, options) => {
    const documentType =
      options.parent.documentType || options.parent.document_type;
    switch (documentType) {
      case DocumentTypes.INE:
        return schema
          .matches(
            /^[A-Z]{6}\d{6}\d{2}[HM]\d\d\d$/i,
            'La clave de elector es inválida.'
          )
          .required('Ingresa un número de documento válido');
      case DocumentTypes.PASSPORT:
        return schema
          .matches(/^[A-Z0-9]{8,20}$/i, 'Pasaporte inválido')
          .required('Ingresa un número de documento válido');
      default:
        return schema.required('Ingresa un número de documento válido');
    }
  }
);

export const documentVerificationValidationSchema = Yup.object().shape({
  documentType: DocumentTypeValidation,
  documentNumber: DocumentNumberValidation,
});
